import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { MmaoChatAnswer } from '@app/store';

/**
 * When seller make a chat answer to negotiation
 */
const events = getEvents((action: MmaoChatAnswer) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'mmaoAnswer',
      buy_or_sell: action.payload.userRole,
      product_brand: action.payload.product.brand.name,
      product_univers: action.payload.product.universe.name,
      product_category: action.payload.product.category.name
    }
  }
]);

export default events;
